import * as React from "react";
import type { SVGProps } from "react";
import { Ref, forwardRef } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgSend = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="#5B6770"
      fillRule="evenodd"
      d="M23.654.343a1.165 1.165 0 0 1 0 1.657L10.662 14.884a1.188 1.188 0 0 1-1.67 0 1.164 1.164 0 0 1 0-1.657L21.984.343a1.188 1.188 0 0 1 1.67 0Z"
      clipRule="evenodd"
    />
    <path
      fill="#5B6770"
      fillRule="evenodd"
      d="M23.654.343c.324.321.431.799.276 1.226l-7.677 21.083a1.82 1.82 0 0 1-.713.862 1.841 1.841 0 0 1-2.642-.749l-3.95-7.836-7.903-3.919a1.826 1.826 0 0 1-.755-.66 1.805 1.805 0 0 1 .869-2.667L22.418.07c.43-.155.912-.048 1.236.273ZM3.18 9.45l7.175 3.558c.23.113.414.297.529.524l3.587 7.116L20.854 3.12 3.18 9.45Z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgSend);
export default ForwardRef;
